<!--
  @component
  Adds text annotations that get their x and y placement using the `xScale` and `yScale`.
 -->
<script>
    import { getContext } from "svelte";

    const { xGet, yGet } = getContext("LayerCake");

    export let projectionFn;

    export let guff;

    let window_width;

    let pt_ca = [-122.5125820175679, 36.42389100758446];
    let pt_oh = [-83.19536340381396, 46.39140992504559];
    let pt_ga = [-80.84894052550632, 31.782535033768795];

    let width_change_oh = 1400;
    $: width_ca = window_width > width_change_oh ? 170 : window_width > 800 ? 140 : 130;
    $: width_oh = window_width > width_change_oh ? 250 : 300;
    $: dy_oh = window_width > width_change_oh ? -105 : -110;
    $: dx_oh = window_width > width_change_oh ? -10 : window_width > 800 ? 20 : 40;
    let width_ga = 150;
</script>

<svelte:window bind:innerWidth={window_width} />

<div class="layercake-annotations">
    <div
        class="layercake-annotation layercake-annotation__bkgd right"
        style="top:{projectionFn(pt_ca)[1]}px; left:{projectionFn(pt_ca)[0] -
            width_ca}px; max-width: {width_ca}px;"
    >
        {@html guff.map_annotation2}
    </div>
    <div
        class="layercake-annotation right"
        style="top:{projectionFn(pt_ca)[1]}px; left:{projectionFn(pt_ca)[0] -
            width_ca}px; max-width: {width_ca}px;"
    >
        {@html guff.map_annotation2}
    </div>

    {#if window_width < width_change_oh}
    <div
        class="layercake-annotation layercake-annotation__bkgd layercake-annotation-oh"
        style="top:{projectionFn(pt_oh)[1] + dy_oh}px; left:{projectionFn(
            pt_oh
        )[0] + dx_oh}px; max-width: {width_oh}px;"
    >
        {@html guff.map_annotation3}
    </div>
    {/if}
    <div
        class="layercake-annotation layercake-annotation-oh"
        style="top:{projectionFn(pt_oh)[1] + dy_oh}px; left:{projectionFn(
            pt_oh
        )[0] + dx_oh}px; max-width: {width_oh}px;"
    >
        {@html guff.map_annotation3}
    </div>

    <!-- GEORGIA -->
    <div
        class="layercake-annotation layercake-annotation__bkgd"
        style="top:{projectionFn(pt_ga)[1] - 10}px; left:{projectionFn(
            pt_ga
        )[0] + 25}px; max-width: {width_ga}px;"
    >
        {@html guff.map_annotation4}
    </div>
    <div
        class="layercake-annotation"
        style="top:{projectionFn(pt_ga)[1] - 10}px; left:{projectionFn(
            pt_ga
        )[0] + 25}px; max-width: {width_ga}px;"
    >
        {@html guff.map_annotation4}
    </div>
</div>

<style>
    .layercake-annotation {
        position: absolute;
        font-size: var(--scale-2);
        line-height: var(--line-height-2);
        min-width: 100px;
        max-width: 200px;
        color: var(--font-darkgray);
    }

    .layercake-annotation__bkgd {
        color: white;
        -webkit-text-stroke: rgba(255, 255, 255, 0.9) 3px;
        filter: drop-shadow(0px 0px 3px rgba(255, 255, 255, 0.9));
    }

    .right {
        text-align: right;
    }
</style>
